import '@fontsource/inter';
import React, { useState } from 'react';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';
import './Health.css';

function Health() {
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks which dropdown is open

  // Toggle function for dropdowns
  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <div className="health-container">
      <CurrentTime />
      <DynamicIsland />
      <Back />
      <div className="tiger-health">
        <img src="./img/towson-health.png" alt="Towson Health" loading="eager" />
        <form className="searchForm">
          <input
            type="search"
            className="searchInput"
            placeholder="Search..."
            aria-label="Search"
          />
        </form>
        <h2 style={{ textAlign: 'center' }}>Welcome, John Doe</h2>
        <div className="health-information">
          <h3>
            TU’s Health Center—a leading university health care provider—offers outstanding care and a range of wellness and health services to all Towson University students.
          </h3>
          <div className="health-dropdown">
          <button
              onClick={() => toggleDropdown('services')}
              className="health-dropdown-button"
            >
          Medical Services           
          </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'services' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
              <h4>Common Illnesses and Minor Injuries</h4>
              <p>The Health Center offers care for common illnesses such as the flu, colds, rashes, nausea, diarrhea, sore throat and urinary tract infections, and more. We can also monitor your health if you have a chronic health problem such as high blood pressure or diabetes. Our providers are experienced in diagnosing and treating the common illnesses often seen among college students. </p>
              <h4>Contraceptive Counseling and Services</h4>
              <p>The Health Center provides prescriptions for the birth control pill, patch, vaginal ring, and Depo-Provera shot. We also have providers who are certified to insert and remove Nexplanon. We offer condoms and other safer sex supplies for free. We also offer emergency contraception at our dispensary (Plan B for $11 and Ella for $39). Call to make an appointment if you have questions about birth control or emergency contraception. In addition to emergency contraception appointments being offered at the Health Center, students can purchase over the counter emergency contraception (names for this are My Way, Plan B, levonorgestrel, Option 2, or PostDay One-Step) at the University Bookstore behind the main counter.  Emergency contraception is also available 24/7 for purchase in the vending machine in the vestibule outside the bookstore in the Union for $10-$18 (price varies by brand).  The vending machine is currently cash only and there is an ATM nearby.   </p>
              <h4>Physical Exams</h4>
              <p>The Health Center offers comprehensive physical examinations for sports participation, travel, pre-operative requirements, and for health professional student requirements. This can include lab work, immunizations and TB skin tests if necessary. </p>
              <h4>HIV and STI Testing</h4>
              <p>We offer testing, diagnosis and treatment for a variety of STIs (sexually transmitted infections). Our clinical staff can also prescribe PrEP to those with an increased risk of acquiring HIV. STI education and counseling is also available by request. 
              <br/>
              You can also book an appointment for free chlamydia, gonorrhea, HIV and hepatitis testing provided by STARTRACK Adolescent Health Program.  This service is separate from the STI testing offered at the Health Center.</p>
              <h4>Immunizations and Tuberculosis (TB) Testing</h4>
              <p>We provide a number of immunizations at the Health Center. Learn more about Immunization Requirements and TB Testing for TU students.</p>
              <h4>Interpretation Services</h4>
              <p>The TU Health Center strives to provide excellent service to students, even when language barriers exist. To do so, we have partnered with CyraCom to provide remote medical interpretation. By using CyraCom services, we are able to provide interpreters via telephone, video call, and even translation of written information. Phone interpretation services are available in 200+ languages. Video interpretation services are available in 25+ languages, including American Sign language. Translation and localization services are available in 300+ languages. We are happy to use Cyracom during appointments to improve patient care as well as communication between provider and patient.</p>
              <h4>Lab Services</h4>
              <p>We have an office lab where we are able to do tests such as: rapid strep, flu and mono tests, urinalysis, pregnancy tests, blood tests for diabetes and anemia. Lab tests that we cannot perform in the Health Center are sent to an accredited private laboratory or the State of Maryland Lab. We have a certified phlebotomist who can draw blood samples and prepare specimens to be sent to outside labs.</p>
              <h4>Minor Office Procedures</h4>
              <p>The Health Center staff is experienced in handling routine office procedures such as simple suturing lacerations and draining abscesses or small cysts.</p>
              <h4>Referral Network of Specialists</h4>
              <p>For services beyond our scope, such as diagnosis and treatment of complex conditions or those requiring specialty care, we have an extensive referral network of local physicians, sports medicine clinics, radiologists and other specialty services. For serious emergencies or hospitalization there are two local hospitals within five minutes of campus. </p>
              <h4>Smoking Cessation</h4>
              <p>The Health Center offers individual smoking cessation counseling and smoking cessation products. If you are interested in quitting smoking you may schedule an appointment with a Tobacco Treatment Specialist or attend one of the cessation classes offered by the Baltimore County Health Department.</p>
            </div>
            <button
              onClick={() => toggleDropdown('student-information')}
              className="health-dropdown-button"
            >
              Student Information
            </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'student-information' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
            <p className="information-category">First Name: <span className="student-information-filled">John</span></p>
            <p className="information-category">Last Name: <span className="student-information-filled">Doe</span></p>
            <p className="information-category">Date of Birth: <span className="student-information-filled">January 1, 2000 (24)</span></p>
            <p className="information-category">Sex: <span className="student-information-filled">Male</span></p>
            <p className="information-category">Pronouns: <span className="student-information-filled">He/Him</span></p>
            <p className="information-category">Blood Type: <span className="student-information-filled">O- (Universal Donor)</span></p>
            <p className="information-category">Wheelchair: <span className="student-information-filled">No</span></p>
            <p className="information-category">Allergies: <span className="student-information-filled">Soy</span></p>

            </div>
            <button
              onClick={() => toggleDropdown('immunization')}
              className="health-dropdown-button"
            >
                Immunization History
            </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'immunization' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
              <p>NOTE: Only the last 3 months of immunization record are shown.</p>
              <table className="student-immunizations">
              <tr>
                <th>Immunization Type</th>
                <th>Date Administered</th>
                <th>Administered By</th>
              </tr>
              <tr>
                <td>MMR</td>
                <td>11/27/2024</td>
                <td>Jane Doe, MD</td>
              </tr>
              <tr>
                <td>TDAP</td>
                <td>11/28/2024</td>
                <td>Jason Doe, MD</td>
              </tr>
            </table>
            </div>
            <button
              onClick={() => toggleDropdown('appointments')}
              className="health-dropdown-button"
            >
                Appointments
            </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'appointments' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
              <h3 id="appointment-type">FOLLOW UP with Jason Doe, MD</h3>
              <h4>Date: Tuesday December 03, 2024</h4>
              <h4>Arrive by 12:30 PM</h4>
              <h4>Location: 1st Floor Clinic Area</h4>
              <img src="./img/qr-code.png" aria-label="QR code for appointment" className="qr-img"/>
              <button type="submit" className="appointment-button">Cancel Appointment</button>
            </div>
            <button
              onClick={() => toggleDropdown('insurance')}
              className="health-dropdown-button"
            >
                Insurance
            </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'insurance' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
              <p>
                
              </p>
            </div>
            <button
              onClick={() => toggleDropdown('record')}
              className="health-dropdown-button"
            >
                Medical Records
            </button>
            <div
              className={`health-dropdown-content ${
                openDropdown === 'record' ? 'dropdown-open' : 'dropdown-closed'
              }`}
            >
              <p>
                
              </p>
            </div>
          </div>
          <div className="health-contact">
          <h2>Health Center</h2>
          <h3>Location: Towson University Health Center at Ward and West</h3>
          <h3>Hours:</h3>
          <p>Monday thru Friday<br/>8 a.m.-5 p.m.</p>
          <h3>Phone: 410-704-2466
            <br/>
            Fax: 410-740-3715
            <br/>
            Email: healthcenter@towson.edu
          </h3>
        </div>
        </div>
      </div>
    </div>
  );
}

export default Health;
